import React, {useEffect, useState, useContext} from "react";
import { Container, Row, Col} from "react-bootstrap";
import {useParams} from "react-router-dom";
import '../components/FrontProductsBlock.css';
import '../components/Catalog/catpanel.css';
import '../components/catalog.css';
import {observer} from "mobx-react-lite";
import SubCatalogList from '../components/Catalog/SubCatalogList';
import CatPanelForCatalog from '../components/Catalog/CatPanelForCatalog';
import FavoriteProducts from '../components/FavoriteProducts';
import CatPanel from '../components/Catalog/CatPanel';
import Breadcrumbs from '../components/Catalog/Breadcrumbs';
import {Context} from "../index";
import { getNewCatalog } from "../http/productAPI";

      
const Catalog = observer(() => {
    const { product } = useContext(Context);        
    const { category } = useParams(); // Получаем параметр из URL
    // Прописываем путь до папки с изображениями
    //      Оптимизация getImagePath
    //      require() нельзя использовать динамически, лучше импортировать изображения заранее или использовать import.meta.glob() в Vite.
    const getImagePath = (imageName) => {
        return require(`../assets/img/CatalogMenu/ImgForCatPanel/${imageName}`);
    };
     useEffect(() => {          
            getNewCatalog().then(data => product.setCategories(data))
        }, [product.selectedFolder])
  
    const [categoryData, setCategoryData] = useState(null);
    const [categoryId, setCategoryId] = useState(null);
    const [isCategoryReady, setIsCategoryReady] = useState(false); // для отслеживания окончания расчётов категорий
    
        // достаём id категории
        const findCategoryRecursive = (categories, categoryUrl) => {
            for (const { url, childCatalogs, ...rest } of categories) {
                if (url === categoryUrl) return { url, childCatalogs, ...rest };
                if (childCatalogs?.length) {
                    const found = findCategoryRecursive(childCatalogs, categoryUrl);
                    if (found) return found;
                }
            }
            return null;
        };
        
        useEffect(() => {
                if (product.categories.length > 0) {
                    const foundIdCategory = findCategoryRecursive(product.categories, category);
                    if (foundIdCategory) {
                        setCategoryId(foundIdCategory.id);
                        setCategoryData(foundIdCategory); 
                    }else {
                        setCategoryData(null);
                      }
                    
                    setIsCategoryReady(true); // <- флаг что поиск завершён
                }
                }, [category, product.categories]); 

                // Следим за изменениями Устанавливаем выбранную папку, когда найден ID категории
                useEffect(() => {
                    if (categoryId) {
                        product.setSelectedFolder({ id: categoryId });
                    }
                }, [categoryId]);

      // Если URL не указан — отображаем главный каталог
  if (!category) {
    return (
      <>
        <Breadcrumbs categories={product?.categories || []} />
        <CatPanel getImagePath={getImagePath} />
      </>
    );
  }

  // Если нашли категорию, но у неё нет подкаталогов — конечная категория
  if (categoryData && categoryData.childCatalogs?.length === 0) {
    return (
      <>
        <Breadcrumbs categories={product?.categories || []} />
        <SubCatalogList categories={product.categories} />
      </>
    );
  }

  // Если есть подкаталоги — показываем панель подкаталогов + избранные
  return (
    <>
      <Breadcrumbs categories={product?.categories || []} />
      <CatPanelForCatalog categoryData={categoryData} getImagePath={getImagePath} />
      <Container>
        <Row>
          <Col className="px-0">
            <Container className="mb-4 products d-flex justify-content-start flex-wrap align-items-stretch px-0">
              <FavoriteProducts />
            </Container>
          </Col>
        </Row>
      </Container>
    </>
  );
});

export default Catalog;
